module.exports = __webpack_public_path__ + "494cd07c/img/menu-icon.5f8facae.svg";